import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/app/HomePage.tsx");
